module.exports = __webpack_public_path__ + "img/down.dd81fda6.png";